import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { User, LogIn } from 'lucide-react';

export default function AuthGate({ isOpen, onClose }) {
  const navigate = useNavigate();

  const handleSignUp = () => {
    // Store current page for redirect after signup
    sessionStorage.setItem('auth_redirect', window.location.pathname + window.location.search);
    // Navigate to /home which shows the auth form in Layout.jsx
    // Pass auth_mode=signup to pre-select signup form
    navigate('/home?auth_mode=signup');
  };

  const handleLogin = () => {
    // Store current page for redirect after login
    sessionStorage.setItem('auth_redirect', window.location.pathname + window.location.search);
    // Navigate to /home which shows the auth form in Layout.jsx
    // Pass auth_mode=login to pre-select login form
    navigate('/home?auth_mode=login');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md bg-brand-950/95 border-brand-800/45 backdrop-blur-xl rounded-2xl">
        <DialogHeader>
          <DialogTitle className="text-2xl text-white flex items-center gap-2">
            <User className="h-6 w-6" />
            Create Account
          </DialogTitle>
          <DialogDescription className="text-white/60 pt-2">
            To continue with your booking and add passenger details, please create an account or sign in.
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-3 pt-4">
          <Button
            onClick={handleSignUp}
            className="w-full bg-gradient-to-r from-[#FF6B6B] to-[#4ECDC4] hover:opacity-90 text-white font-medium h-12"
          >
            <User className="h-4 w-4 mr-2" />
            Create Account
          </Button>

          <Button
            onClick={handleLogin}
            variant="outline"
            className="w-full bg-white border-white/20 text-black hover:bg-white/90 h-12 rounded-full"
          >
            <LogIn className="h-4 w-4 mr-2" />
            Already have an account? Sign In
          </Button>
        </div>

        <p className="text-xs text-white/60 text-center pt-4">
          Your search and selected flights will be saved
        </p>
      </DialogContent>
    </Dialog>
  );
}
